<template>
  <div class="search-box container">
    <el-form
      class="search-form"
      :label-position="labelPosition"
      :model="{}"
    >
      <el-col
        :sm="8"
        :md="8"
        :lg="8"
        :xl="8"
      >
        <el-form-item class="search">
          <el-input
            v-model="search"
            :placeholder="$t('search.top.filter.search.label')"
          />
        </el-form-item>
      </el-col>
      <el-col
        v-if="category && category.subcategories && category.subcategories.length"
        :sm="7"
        :md="7"
        :lg="7"
        :xl="7"
      >
        <el-form-item class="subcategory">
          <select-primary-js
            v-model="subcategory"
            placeholder="Subcategory"
            label="subcategory"
            :searchable="false"
            :options="subcategoryOptions"
          >
            <template
              slot="singleLabel"
              slot-scope="props"
            >
              <div class="select-primary-wrapper">
                <div class="select-primary-icon">
                  <i :class="'icon-'+ props.option.key" />
                </div>
                <span class="option__desc">
                  <span class="option__title">{{ $t('select.primary.js.item.' + props.option.key ) }}</span>
                </span>
              </div>
            </template>
          </select-primary-js>
        </el-form-item>
      </el-col>
      <el-col
        :sm="5"
        :md="5"
        :lg="5"
        :xl="5"
      >
        <el-form-item class="location">
          <location />
        </el-form-item>
      </el-col>
      <!--<el-col :sm="4" v-if="location">-->
      <!--<el-form-item class="km">-->
      <!--<select-primary-js-->
      <!--placeholder="Radius"-->
      <!--label="radius"-->
      <!--v-model="radius"-->
      <!--:item-key="'value'"-->
      <!--:searchable="false"-->
      <!--:options="radiusOptions">-->
      <!--</select-primary-js>-->
      <!--</el-form-item>-->
      <!--</el-col>-->
    </el-form>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import mutations from '@/store/filters/filters.mutationlist';
import { autoState } from '@fps/vue-toolkit/dist/util';
import SelectPrimaryJs from '@/components/MainLeftFilters/SelectPrimaryJs';
import Location from '@/components/MainLeftFilters/Location';

export default {
  components: {
    SelectPrimaryJs,
    Location,
  },
  data() {
    return {
      labelPosition: 'left',
      name: 'TopSearch',
    };
  },
  computed: {
    subcategory: {
      get() {
        return this.$store.state.filters.subcategory;
      },
      set(value) {
        if (value !== this.subcategory) {
          this.$store.dispatch('setSubcategory', value);
        }
      },
    },
    subcategoryOptions() {
      return this.category && this.category.subcategories && this.category.subcategories.length
        ? this.category.subcategories.map(item => ({
          ...item,
          name: this.$t(`subcategory.${this.category.key}.${item.key}`),
        }))
        : [];
    },
    ...autoState(['search'], mutations.FILTER_SET, 500, 'filters'),
    // ...autoState(['radius'], mutations.FILTER_SET, 0, 'filters'),
    ...mapState({
      category: state => state.filters.category,
      // radiusOptions: state => state.config.rangeOptions,
    }),
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/TopFilter.vue